import * as dialog from './dialog';

export default {
  ...dialog,
};
